// Shared helpers for client registration flows
import { api } from "@/lib/api";

/**
 * If dateStr is in the past, bump year to current (or next if current still past).
 * Returns { date, adjusted }.
 */
export function fixPastYear(dateStr) {
  if (!dateStr) return { date: null, adjusted: false };
  const parsed = new Date(dateStr.length <= 10 ? dateStr + "T12:00:00" : dateStr);
  if (isNaN(parsed.getTime())) return { date: dateStr, adjusted: false };
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const d = new Date(parsed);
  d.setHours(0, 0, 0, 0);
  if (d >= today) return { date: dateStr, adjusted: false };
  const month = parsed.getMonth();
  const day = parsed.getDate();
  const curYear = today.getFullYear();
  let candidate = new Date(curYear, month, day);
  candidate.setHours(0, 0, 0, 0);
  if (candidate < today) {
    candidate = new Date(curYear + 1, month, day);
  }
  const iso = candidate.toISOString().slice(0, 10);
  return { date: iso, adjusted: true };
}

/** Returns today in YYYY-MM-DD (local) */
export function todayIso() {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  const tz = d.getTimezoneOffset() * 60000;
  return new Date(d - tz).toISOString().slice(0, 10);
}

/** Normalize a phone, return last 9 digits (or 8 for landline). null if < 8 digits. */
export function phoneKey(raw) {
  const digits = (raw || "").replace(/\D+/g, "");
  if (digits.length < 8) return null;
  return digits.length >= 9 ? digits.slice(-9) : digits.slice(-8);
}

/** Query backend for an existing client with the same phone. excludeId skips self-match on edit. */
export async function findPhoneMatch(telefone, excludeId) {
  if (!phoneKey(telefone)) return null;
  try {
    const params = { telefone };
    if (excludeId) params.exclude_id = excludeId;
    const r = await api.get("/clientes/match-phone", { params });
    return r.data?.match || null;
  } catch {
    return null;
  }
}
